import solicitudFuncionesServices from '@/services/solicitudFunciones.services'

const generarIdRegistroFuncion = () => `reg-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`

const normalizarFuncionesAsignadas = (funciones = []) =>
	funciones.map((funcion) => ({
		...funcion,
		idRegistroFuncion: funcion.idRegistroFuncion || generarIdRegistroFuncion(),
	}))

const obtenerItemsRespuesta = (response) => {
	const data = response?.data
	if (Array.isArray(data?.data)) return data.data
	if (Array.isArray(data)) return data
	return []
}

const normalizarCatalogoFunciones = (items = []) =>
	items
		.map((item) => ({
			id: item?.id ?? item?.id_funcion ?? null,
			nombre: item?.nombre ?? item?.funcion ?? item?.name ?? '',
		}))
		.filter((item) => item.id !== null && item.nombre)

const normalizarCatalogoTiposCompensacion = (items = []) =>
	items
		.map((item) => ({
			id: item?.id ?? item?.id_tipo_compensacion ?? null,
			nombre: item?.nombre ?? item?.tipo_compensacion ?? item?.name ?? '',
		}))
		.filter((item) => item.id !== null && item.nombre)

const normalizarFuncionesSubsanarBase = (items = []) =>
	items
		.map((item) => ({
			id: item?.id ?? item?.id_funcion ?? null,
			nombre: item?.nombre ?? item?.nombre_funcion ?? item?.funcion ?? '',
		}))
		.filter((item) => item.id !== null && item.nombre)

const normalizarIdComparable = (value) => String(value ?? '').trim()

const normalizarBotonera = (items = []) =>
	(Array.isArray(items) ? items : [])
		.map((item) => ({
			tipo: String(item?.tipo || '').trim(),
			mostrar: Boolean(item?.mostrar),
		}))
		.filter((item) => item.tipo)

const crearFuncionDraft = () => ({
	mode: 'create',
	idRegistroFuncion: null,
	funcionId: null,
	tipoCompensacionId: null,
	valorAsignado: '',
	nuevaActividad: '',
	actividades: [],
})

export default {
	namespaced: true,
	state: {
		idEmpleadoPuesto: null,
		inicioFuncion: '',
		funcionesCatalogo: [],
		funcionesSubsanarBase: [],
		idSolicitudSubsanarContexto: null,
		idEstadoSolicitudSubsanarContexto: null,
		idEstadoSolicitudJefeContexto: null,
		esCargaInicialContexto: false,
		esJefeUnidadContexto: false,
		editarCargaInicialContexto: false,
		botoneraSubsanarContexto: [],
		tiposCompensacion: [],
		funcionesAsignadas: [],
		funcionDraft: crearFuncionDraft(),
		montoMaximoPermitido: null,
	},
	mutations: {
		setIdEmpleadoPuesto(state, idEmpleadoPuesto) {
			state.idEmpleadoPuesto = idEmpleadoPuesto ?? null
		},
		setMontoMaximoPermitido(state, monto) {
			const valor = Number(monto)
			state.montoMaximoPermitido = Number.isFinite(valor) ? valor : null
		},
		setInicioFuncion(state, inicioFuncion) {
			state.inicioFuncion = inicioFuncion || ''
		},
		setFuncionesCatalogo(state, funcionesCatalogo) {
			state.funcionesCatalogo = Array.isArray(funcionesCatalogo) ? funcionesCatalogo : []
		},
		setFuncionesSubsanarBase(state, funcionesSubsanarBase) {
			state.funcionesSubsanarBase = Array.isArray(funcionesSubsanarBase)
				? normalizarFuncionesSubsanarBase(funcionesSubsanarBase)
				: []
		},
		setContextoSubsanar(state, { idSolicitud, idEstadoSolicitud, idEstadoSolicitudJefe, botonera, esCargaInicial, esJefeUnidad, editarCargaInicial } = {}) {
			state.idSolicitudSubsanarContexto = idSolicitud ? String(idSolicitud).trim() : null
			state.idEstadoSolicitudSubsanarContexto = Number.isFinite(Number(idEstadoSolicitud))
				? Number(idEstadoSolicitud)
				: null
			state.idEstadoSolicitudJefeContexto = Number.isFinite(Number(idEstadoSolicitudJefe))
				? Number(idEstadoSolicitudJefe)
				: null
			state.esCargaInicialContexto = Boolean(esCargaInicial)
			state.esJefeUnidadContexto = Boolean(esJefeUnidad)
			state.editarCargaInicialContexto = Boolean(editarCargaInicial)
			state.botoneraSubsanarContexto = normalizarBotonera(botonera)
		},
		setTiposCompensacion(state, tiposCompensacion) {
			state.tiposCompensacion = Array.isArray(tiposCompensacion) ? tiposCompensacion : []
		},
		setFuncionesAsignadas(state, funciones) {
			state.funcionesAsignadas = Array.isArray(funciones) ? normalizarFuncionesAsignadas(funciones) : []
		},
		setFuncionDraft(state, draft) {
			state.funcionDraft = {
				...state.funcionDraft,
				...draft,
			}
		},
		resetFuncionDraft(state) {
			state.funcionDraft = crearFuncionDraft()
		},
		agregarActividadDraft(state, actividad) {
			const actividadNormalizada = (actividad || '').trim()
			if (!actividadNormalizada) return
			const actividadExiste = (state.funcionDraft.actividades || []).some(
				(item) => (item.nombre || '').trim().toLowerCase() === actividadNormalizada.toLowerCase()
			)
			if (actividadExiste) return
			state.funcionDraft.actividades = [
				...state.funcionDraft.actividades,
				{ nombre: actividadNormalizada },
			]
			state.funcionDraft.nuevaActividad = ''
		},
		eliminarActividadDraft(state, actividadIndex) {
			state.funcionDraft.actividades = state.funcionDraft.actividades.filter((_, index) => index !== actividadIndex)
		},
		eliminarFuncionAsignada(state, idRegistroFuncion) {
			state.funcionesAsignadas = state.funcionesAsignadas.filter(
				(item) => item.idRegistroFuncion !== idRegistroFuncion
			)
		},
		guardarFuncionAsignadaDesdeDraft(state) {
			const funcionIdDraft = normalizarIdComparable(state.funcionDraft.funcionId)
			const funcionExistente = state.funcionesAsignadas.find(
				(item) => item.idRegistroFuncion === state.funcionDraft.idRegistroFuncion
			)
			const funcionSeleccionadaCatalogo = state.funcionesCatalogo.find(
				(item) => normalizarIdComparable(item?.id) === funcionIdDraft
			)
			const funcionSeleccionadaSubsanarBase = state.funcionesSubsanarBase.find(
				(item) => normalizarIdComparable(item?.id) === funcionIdDraft
			)
			const funcionSeleccionada = funcionSeleccionadaCatalogo || funcionSeleccionadaSubsanarBase || (funcionExistente?.id_funcion
				? {
					id: funcionExistente.id_funcion,
					nombre: funcionExistente.funcion,
				}
				: null)

			const tipoCompensacionCatalogo = state.tiposCompensacion.find((item) => item.id === state.funcionDraft.tipoCompensacionId)
			const tipoCompensacionSeleccionada = tipoCompensacionCatalogo || (funcionExistente?.tipo_compensacion?.id
				? {
					id: funcionExistente.tipo_compensacion.id,
					nombre: funcionExistente.tipo_compensacion.nombre,
				}
				: null)

			if (!funcionSeleccionada || !tipoCompensacionSeleccionada) {
				return
			}

			const existeFuncion = state.funcionesAsignadas.some((item) => {
				if (item.idRegistroFuncion === state.funcionDraft.idRegistroFuncion) return false
				return normalizarIdComparable(item?.id_funcion) === normalizarIdComparable(funcionSeleccionada.id)
			})
			if (existeFuncion) {
				return
			}

			const actividadesUnicas = []
			const actividadesMap = new Set()
			for (const actividad of state.funcionDraft.actividades || []) {
				const idActividad = actividad?.id ?? null
				const nombreActividad = (actividad?.nombre || '').trim()
				if (!nombreActividad) continue
				const actividadKey = nombreActividad.toLowerCase()
				if (actividadesMap.has(actividadKey)) continue
				actividadesMap.add(actividadKey)
				actividadesUnicas.push({ id: idActividad, nombre: nombreActividad })
			}

			const payload = {
				idRegistroFuncion: state.funcionDraft.idRegistroFuncion || generarIdRegistroFuncion(),
				id_funcion: funcionSeleccionada.id,
				id_funcion_asignada: funcionExistente?.id_funcion_asignada ?? null,
				funcion: funcionSeleccionada.nombre,
				tipo_compensacion: { ...tipoCompensacionSeleccionada },
				valor_asignado: Number(state.funcionDraft.valorAsignado || 0),
				id_estado: funcionExistente?.id_estado ?? null,
				nombre_estado: funcionExistente?.nombre_estado ?? null,
				actividades: actividadesUnicas,
			}

			if (Number(tipoCompensacionSeleccionada.id) !== 2) {
				payload.valor_asignado = 0
			}

			const funcionIndex = state.funcionesAsignadas.findIndex((item) => item.idRegistroFuncion === payload.idRegistroFuncion)
			if (funcionIndex >= 0) {
				state.funcionesAsignadas.splice(funcionIndex, 1, payload)
			} else {
				state.funcionesAsignadas.push(payload)
			}
		},
		actualizarEstadoFuncionAsignada(state, { idRegistroFuncion, idEstado, nombreEstado }) {
			state.funcionesAsignadas = state.funcionesAsignadas.map((item) => {
				if (item.idRegistroFuncion !== idRegistroFuncion) return item
				return {
					...item,
					id_estado: Number(idEstado),
					nombre_estado: nombreEstado || item.nombre_estado || null,
				}
			})
		},
		resetSolicitudFunciones(state) {
			state.idEmpleadoPuesto = null
			state.inicioFuncion = ''
			state.funcionesCatalogo = []
			state.funcionesSubsanarBase = []
			state.idSolicitudSubsanarContexto = null
			state.idEstadoSolicitudSubsanarContexto = null
			state.idEstadoSolicitudJefeContexto = null
			state.esCargaInicialContexto = false
			state.esJefeUnidadContexto = false
			state.editarCargaInicialContexto = false
			state.botoneraSubsanarContexto = []
			state.tiposCompensacion = []
			state.funcionesAsignadas = []
			state.funcionDraft = crearFuncionDraft()
			state.montoMaximoPermitido = null
		},
	},
	actions: {
		setIdEmpleadoPuesto({ commit }, idEmpleadoPuesto) {
			commit('setIdEmpleadoPuesto', idEmpleadoPuesto)
		},
		setMontoMaximoPermitido({ commit }, monto) {
			commit('setMontoMaximoPermitido', monto)
		},
		setInicioFuncion({ commit }, inicioFuncion) {
			commit('setInicioFuncion', inicioFuncion)
		},
		setFuncionesCatalogo({ commit }, funcionesCatalogo) {
			commit('setFuncionesCatalogo', funcionesCatalogo)
		},
		setFuncionesSubsanarBase({ commit }, funcionesSubsanarBase) {
			commit('setFuncionesSubsanarBase', funcionesSubsanarBase)
		},
		setContextoSubsanar({ commit }, payload) {
			commit('setContextoSubsanar', payload)
		},
		async cargarCatalogoFunciones({ commit }, idEmpleadoPuesto) {
			if (!idEmpleadoPuesto) {
				commit('setFuncionesCatalogo', [])
				return
			}

			try {
				const response = await solicitudFuncionesServices.getCatalogoFuncionesPorEmpleadoPuesto(idEmpleadoPuesto)
				const items = obtenerItemsRespuesta(response)
				commit('setFuncionesCatalogo', normalizarCatalogoFunciones(items))
			} catch (error) {
				commit('setFuncionesCatalogo', [])
				console.error('Error al cargar catalogo de funciones:', error)
			}
		},
		setTiposCompensacion({ commit }, tiposCompensacion) {
			commit('setTiposCompensacion', tiposCompensacion)
		},
		async cargarTiposCompensacion({ commit }) {
			try {
				const response = await solicitudFuncionesServices.getCatalogoTiposCompensacion()
				const items = obtenerItemsRespuesta(response)
				commit('setTiposCompensacion', normalizarCatalogoTiposCompensacion(items))
			} catch (error) {
				commit('setTiposCompensacion', [])
				console.error('Error al cargar tipos de compensacion:', error)
			}
		},
		setFuncionesAsignadas({ commit }, funciones) {
			commit('setFuncionesAsignadas', funciones)
		},
		setFuncionDraft({ commit }, draft) {
			commit('setFuncionDraft', draft)
		},
		resetFuncionDraft({ commit }) {
			commit('resetFuncionDraft')
		},
		agregarActividadDraft({ commit }, actividad) {
			commit('agregarActividadDraft', actividad)
		},
		eliminarActividadDraft({ commit }, actividadIndex) {
			commit('eliminarActividadDraft', actividadIndex)
		},
		eliminarFuncionAsignada({ commit }, idRegistroFuncion) {
			commit('eliminarFuncionAsignada', idRegistroFuncion)
		},
		actualizarEstadoFuncionAsignada({ commit }, payload) {
			commit('actualizarEstadoFuncionAsignada', payload)
		},
		guardarFuncionAsignadaDesdeDraft({ commit }) {
			commit('guardarFuncionAsignadaDesdeDraft')
		},
	},
}
